import {Label, Modal, ModalBody, ModalFooter} from "reactstrap";
import React from "react";
import Select from "react-select";
import {getFieldWidget, getUpdatedFieldValue} from "./Appcommon";

class MassUpdate extends React.Component {

    constructor(props) {
        super(props);

        let {formname, formDetail} = this.props;

        let fieldDetails = formDetail[1];
        let fields = {};
        fieldDetails.map((field, index)=> {
            let fieldName = field[2];
            fields[fieldName] = field;
        });

        this.state = {
            selectedField : [],
            fields : fields,
            dataRow : {},
        }
    }

    toggleModal = () => {

    }

    onMassEditFieldChange = (selectedOption) => {
        this.setState({
            selectedField : selectedOption
        })
    }

    onChange = (e, valueInfo, attributes) => {
        let {dataRow} = this.state;
        dataRow = getUpdatedFieldValue(valueInfo,attributes,dataRow);
        this.setState({
            dataRow
        });
    }

    onMassEditPanelClose = () => {
        let {onMassEditClose} = this.props;
        this.setState({
            selectedField : [],
            dataRow : {},
        })
        onMassEditClose();
    }

    onMassEditSubmit = async (e, selectedOption, selectedField) => {
        let {updateMassFields} = this.props;
        await updateMassFields(e, selectedOption, this.state.dataRow, selectedField);
        this.setState({
            selectedField : [],
            dataRow : {},
        })
    }

    render() {
        let {formname, formDetail, isMassUpdate,selectedRows, onMassEditClose, updateMassFields} = this.props;
        let formInfo = formDetail[0];
        let formLabel = formInfo[2];
        let fieldDetails = formDetail[1];
        let fieldsOptions = [];
        let selectedOption = this.state.selectedField;
        let fieldList = this.state.fields;
        let selectedField = fieldList[selectedOption.value];
        let fieldWidget = "";
        if(selectedField !== undefined) {
            fieldWidget = getFieldWidget(selectedField, this.onChange, {} ,this.state.dataRow);
        }
        fieldDetails.map((field, index)=> {
            let fieldName = field[2];
            let fieldLabel = field[3];
            let fieldType = field[4];
            let isConfigHide = parseInt(field[10]);
            let isViewHide = parseInt(field[11]);
            let isMassEditAllowed = parseInt(field[25]);
            if(!isConfigHide && !isViewHide) {
                if (isMassEditAllowed && fieldLabel.indexOf("_id") === -1) {
                    if(selectedOption.length === 0 && index === 0){
                        selectedOption = {
                            value: fieldName, label: fieldLabel
                        };
                    }
                    fieldsOptions.push({
                        value: fieldName, label: fieldLabel
                    })
                }
            }
        });
        return (
            <Modal isOpen={this.props.isMassUpdate} toggle={this.toggleModal} className={'delete-modal'}>
                <ModalBody>
                    <div className={'modal-update-header flex-center-v'}>
                        <span>Update Field</span>
                        <span className="ux-bullet-primary"></span>
                        <span className="f15 color-555"> {selectedRows.length +" "+ formLabel} Selected </span>
                    </div>
                    <div className={'modal-update-content'}>
                        <div className={`mb-3`}>
                            <Label className={'form-label'}>Select a field</Label>
                            <Select
                                menuPosition="fixed"
                                classNamePrefix="le-select"
                                required={true}
                                onChange={(e) => {this.onMassEditFieldChange(e)}}
                                value={selectedOption}
                                name="mass-update-fields"
                                id="mass-update-fields"
                                options={fieldsOptions}
                            />
                        </div>
                        <div mb-3>
                            <Label>{selectedOption.label}</Label>
                            {fieldWidget !== "" && fieldWidget}
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <button className={'btn-wide mb-2 me-2 btn-pill btn btn-light'} onClick={(e) => {this.onMassEditPanelClose(e)}}>
                        Cancel
                    </button>
                    <button className={'btn-wide mb-2 me-2 btn-pill btn btn-danger'} onClick={(e) => {this.onMassEditSubmit(e, selectedOption, selectedField)}}>
                        Update
                    </button>
                </ModalFooter>
            </Modal>
        )
    }
}

export default MassUpdate;
